import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
import Post from './Post';
import FileBrowser from "./FileBrowser"; 
import FirstNews from './FirstNews';

const Kepegawaian = () =>{
    const [posts, setPosts] = useState([]);
    const [firstNews, setFirstNews] = useState(null);
    const [items, setItems] = useState([]);
    const [currentFolder, setCurrentFolder] = useState(
        "1LRxvKSXROGVOsKzcgt_YWU4ho5pAYcnR"
    ); // root folder
   
    const apiKey = "AIzaSyDTGuWnYrsERgu6hAkSnZep-uswuOMZ_14"
    
  return(
        <div>
            <div class="ttm-page-title-row">
                <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12" style={{textAlign:'left'}}>
                                <div class="page-title-heading">
                                    <h2 class="title">Bagian Perencanaan</h2>
                                </div>
                                <div class="breadcrumb-wrapper">
                                    <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="/profil"> Profil</a></span>                              
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="site-main">
                <div class="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix" style={{paddingTop: "0px"}}>
                    <div class="container">                    
                        <div class="row">
                            <div class="col-xl-9 col-lg-8 content-area" style={{textAlign:'left'}}>
                            <article class="post ttm-blog-single clearfix">
    
        <div class="ttm-blog-single-content">
            <div class="entry-content mt-5">
                <div class="ttm-box-desc-text">
 <div>
    <FileBrowser 
            folderBase="/documents/perencanaan" bag="perencanaan"
            />
    </div>

                </div>
            </div>
        </div>
    
    </article>                          
                            </div>
                            <div class="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>

                         <FirstNews />
                </div>
                        </div>
                    
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Kepegawaian;